<template>
    <div id="pageTable">
        <v-container 
            class="d-flex align-center justify-center" 
            style="height: 80vh; width: 80vw;"
            v-if="rol == 'empleado' || rol == 'admin-depto'"
        >
			<v-card class="" style="border-radius:20px" max-width="500">
                <v-card-title class="justify-center card_titulo">
                    <div class="headerModal">
                        <img :src="'/static/icon/peligro.svg'" class="imgModal"/>
                    </div>
                </v-card-title>
                <v-card-text class="titleModal text-center">
                    Esta vista no esta disponible para este rol de usuario.
                </v-card-text>
                <v-card-actions class="d-flex align-center justify-center card_accion">
                    <v-btn
                        class="btnGuardar"
                        @click="redireccionar()"
                    >
                        Ok
                    </v-btn>
                </v-card-actions>
            </v-card>
		</v-container>
        <v-container xl fluid v-else>
            <v-row>
                <v-col cols="12" lg="12">
                    <data-table
                        ref="tabla"
                        :tableName="'Cocinas'"
                        :url="url"
                        :columns="columns"
                        :filters="filters"
                        @setFilters="setFilters"
                        @loadModalData="loadModalData"
                        :perPage="[10, 25, 50, 100]"
                        :showAdvancedFilters="true"
                    >
                        <template slot="actionButtonsLeft">
                            <div class="botonAgregar">
                                <v-btn
                                    rounded
                                    color="#004BAF"
                                    class="btnAdd"
                                    right
                                    @click="abrirModal('add')"
                                >
                                    <v-icon dark class="mr-2">add</v-icon>Agregar
                                    <div class="mr-4"></div>
                                </v-btn>
                            </div>
                        </template>

                        <template slot="filters">
                            <v-col v-if="rol == 'root'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="clientes"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Cliente"
                                    persistent-hint
                                    v-model="cliente_value"
                                    no-data-text="Datos no disponibles"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col v-if="rol == 'root' || rol  == 'admin'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    :items="empresas"
                                    item-text="nombre"
                                    item-value="id"
                                    label="Empresa"
                                    persistent-hint
                                    v-model="empresa_value"
                                    no-data-text="Datos no disponibles"
                                >
                                </v-autocomplete>
                            </v-col>
                            <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-autocomplete
                                    outlined
                                    label="Sucursal"
                                    :items="sucursales"
                                    item-text="nombre"
                                    item-value="id"
                                    persistent-hint
                                    v-model="sucursal_value"
                                >
                                </v-autocomplete>
                            </v-col>

                            <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                <v-text-field 
                                    outlined 
                                    label="Nombre de la cocina" 
                                    v-model="filterNombre"
                                >
                                </v-text-field>
                            </v-col>

                        </template>

                        <tbody slot="body" slot-scope="{ data }">
                            <tr :key="item.id" v-for="item in data">
                                <td>
                                    <div class="tblPrincipal">{{ item.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.cliente.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.empresa.nombre }}</div>
                                </td>
                                <td>
                                    <div class="tblPrincipal">{{ item.descripcion }}</div>
                                </td>
                                <td>
                                    <div class="tblOpciones">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    icon
                                                    fab
                                                    dark
                                                    @click="abrirModal('update', item)"
                                                    small
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotones">edit</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Editar</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    v-on="on"
                                                    slot="activator"
                                                    class="botonHover"
                                                    depressed
                                                    icon
                                                    fab
                                                    dark
                                                    small
                                                    @click="eliminar(item)"
                                                >
                                                    <v-icon class="tamIconoBoton invertirColorBotonesDelete">delete</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Eliminar</span>
                                        </v-tooltip>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </data-table>
                </v-col>
            </v-row>

            <template class="borde-card">
                <v-dialog v-model="dialog" persistent max-width="750px" class="borde-card">
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" class="botonModal" id="btnModal"></v-btn>
                    </template>
                    <v-card class="borde-card">
                        <ValidationObserver ref="form" v-slot="{ invalid }">
                            <v-card-title class="card_titulo padding_izquierdo padding_derecho">
                                <div class="headerModalStart">
                                    <h2 class="titleModal_700_18">{{ tituloModal }}</h2>
                                </div>
                            </v-card-title>
                            <!-- <v-card-title class="justify-center card_titulo">
                                <div class="headerModal">
                                    <img :src="imagen" class="imgModal" />
                                    <h2 class="titleModal">{{ tituloModal }}</h2>
                                </div>
                            </v-card-title> -->

                            <v-card-text class="card_texto">
                                <div id="padre" v-show="isLoadingModal">
                                    <div id="loading">
                                        <v-progress-circular indeterminate :size="100" :width="7" color="blue"></v-progress-circular> 
                                    </div>
                                </div>
                                
                                <v-container v-show="!isLoadingModal" grid-list-md id="contenedor">
                                    <v-row class="my-5">
                                        <v-col v-if="rol == 'root'" cols="12" xs="12" sm="12" md="12" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="cliente" rules="required">
                                                <v-autocomplete
                                                    outlined
                                                    :items="clientes"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Cliente"
                                                    persistent-hint
                                                    v-model="cliente_value"
                                                    :error-messages="errors"
                                                    no-data-text="Datos no disponibles"
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col v-if="rol == 'root' || rol == 'admin'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="empresa" rules="required">
                                                <v-autocomplete
                                                    outlined
                                                    :items="empresas"
                                                    item-text="nombre"
                                                    item-value="id"
                                                    label="Empresa"
                                                    persistent-hint
                                                    v-model="empresa_value"
                                                    :error-messages="errors"
                                                    no-data-text="Datos no disponibles"
                                                />
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col v-if="rol == 'root' || rol == 'admin' || rol == 'admin-empresa'" cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <VuetifyMultipleAutocomplete
                                                outlined
                                                :items="sucursales"
                                                :valorDefecto="sucursalesSeleccionadas"
                                                item_text="nombre"
                                                @dataMultiple="(data)=> sucursalesSeleccionadas = data"
                                                label="Sucursales"
                                                ref="multSucursal"
                                                :rules="'required'"
                                            />
                                        </v-col>
                                        
                                        <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                            <ValidationProvider v-slot="{ errors }" name="Nombre" rules="required">
                                                <v-text-field 
                                                    outlined
                                                    label="Nombre" 
                                                    class="pa-0 ma-0" 
                                                    v-model="cocina.nombre" 
                                                    :error-messages="errors" 
                                                    required
                                                >
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                            <ValidationProvider v-slot="{ errors }" name="Descripción" rules="required">
                                                <v-text-field 
                                                    outlined
                                                    label="Descripción" 
                                                    class="pa-0 ma-0" 
                                                    v-model="cocina.descripcion" 
                                                    :error-messages="errors" 
                                                    required
                                                >
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                            <ValidationProvider v-slot="{ errors }" name="Dirección" rules="required">
                                                <v-text-field 
                                                    outlined
                                                    label="Dirección" 
                                                    class="pa-0 ma-0" 
                                                    v-model="cocina.direccion" 
                                                    :error-messages="errors" 
                                                    required
                                                >
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="pt-0 pb-0 ma-0">
                                            <ValidationProvider v-slot="{ errors }" name="Responsable" rules="required">
                                                <v-text-field 
                                                    outlined
                                                    label="Responsable" 
                                                    class="pa-0 ma-0" 
                                                    v-model="cocina.responsable" 
                                                    :error-messages="errors" 
                                                    required
                                                >
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Teléfono" rules="required">
                                                <v-text-field
                                                    outlined
                                                    label="Teléfono"
                                                    v-model="cocina.numero"
                                                    :error-messages="errors"
                                                    auto
                                                    v-mask="'(###) ###-####'"
                                                ></v-text-field>
                                            </ValidationProvider>
                                        </v-col>

                                        <v-col cols="12" xs="12" sm="6" md="6" class="py-0">
                                            <ValidationProvider v-slot="{ errors }" name="Hora máxima" rules="required">
                                                <v-text-field
                                                    outlined
                                                    label="Hora máxima"
                                                    v-model="cocina.hora_maxima"
                                                    id="hora_maxima"
                                                    type="time"
                                                    :error-messages="errors" 
                                                    required
                                                >
                                                    <template v-slot:append-outer>
                                                        <v-tooltip top class="pb-7">
                                                            <template v-slot:activator="{ on }">
                                                                <v-icon color='#96999A' v-on="on" slot="activator" class="pb-7 pl-2 outlined_v_icon">info</v-icon>
                                                            </template>
                                                            <span class="pb-7 textTooltip">Establecer para los empleados, un <br> horario máximo para realizar un <br> pedido. Ejemplo: 10:00 a.m.</span>
                                                        </v-tooltip>  
                                                    </template>
                                            
                                                </v-text-field>
                                            </ValidationProvider>
                                        </v-col>
                                        
                                    </v-row>
                                </v-container>
                            </v-card-text>
                            <v-card-actions class="d-flex justify-end card_accion">
                                <button
                                    class="btnCerrar"
                                    @click="cerrarModal()" 
                                    :disabled="isSaving"
                                >
                                    Cancelar
                                </button>
                                <v-btn
                                    class="btnGuardar"
                                    @click="guardar()" 
                                    :disabled="invalid" 
                                    :loading="isSaving"
                                >
                                    Guardar
                                </v-btn>
                            </v-card-actions>
                        </ValidationObserver>
                    </v-card>
                </v-dialog>
            </template>
        </v-container>
    </div>
</template>

<script>
/* API's */
import apiCocinas from "@/api/comidas/cocinas";
import apiClientes from '@/api/clientes';
import apiEmpresas from '@/api/empresas';
import apiSucursales from '@/api/sucursales';

/* COMPONENTES */
import Datatable from "@/components/datatable/Datatable.vue";
import VuetifyMultipleAutocomplete from '@/components/VuetifyMultipleAutocomplete2.vue';

//PLUGINS
import Notify from '@/plugins/notify';

export default {
    components: {
        "data-table": Datatable,
        VuetifyMultipleAutocomplete,
    },

    data() {
        return {
            datosLogin  : null,
            rol         : null,
            url: "comida-cocina/find",
            columns: [
                {
                    label: "Nombre",
                    name: "nombre",
                    filterable: false,
                },
                {
                    label: "Cliente",
                    name: "cliente",
                    filterable: false,
                },
                {
                    label: "Empresa",
                    name: "empresa",
                    filterable: false,
                },
                {
                    label: "Descripción",
                    name: "descripcion",
                    filterable: false,
                },
                {
                    label: "Opciones",
                    name: "opciones",
                    filterable: false,
                    align: 'center'
                },
            ],
            filters: {
                activo      : true,
                paginate    : true,
                order_by    : 'nombre',
                cliente_id  : null,
                empresa_id  : null,
                sucursal_id : null,
                nombre      : null,
            },
            cocina: {
                id          : null,
                cliente_id  : null,
                empresa_id  : null,
                nombre      : null,
                descripcion : null,
                direccion   : null,
                responsable : null,
                numero      : null,
                hora_maxima : null,
                sucursales  : [],
            },
            tituloModal     : '',
            imagen          : '',
            accion          : '',
            isLoadingModal  : false,
            isLoading       : false,
            dialog          : false,
            isSaving        : false,
            cliente_value   : null,
            empresa_value   : null,
            sucursal_value  : null,
            sucursalesSeleccionadas: [],
            clientes        : [],
            empresas        : [],
            sucursales      : [],

            filterNombre    : null,
        }
    },
    watch: {
        cliente_value: function(val) {
            if(val != null){
                this.getEmpresas(val);
            }
        },
        empresa_value: function(val) {
            this.sucursalesSeleccionadas = [];
            if(val != null){
                this.getSucursales(val);
            }
        },
    },
    methods: {
        async abrirModal(accion, data = null){
            await this.resetValues();
            this.accion         = accion;
            this.isLoadingModal = true;

            if(accion == "add"){
                this.tituloModal    = "Agregar nueva cocina";
                this.imagen         = "/static/modal/brigadasCreate.svg";
                if(this.rol == 'root'){
                    this.getClientes();
                }
                else if(this.rol == 'admin'){
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.getEmpresas(this.cliente_value);
                }
                else if(this.rol == 'admin-empresa'){
                    this.cliente_value = this.datosLogin.cliente_id;
                    this.empresa_value = this.datosLogin.empresa_id;
                }
                else {
                    this.empresa_value = this.datosLogin.empresa_id;
                    this.sucursal_value = this.datosLogin.sucursal_id;
                }
                
            } else {
                this.tituloModal        = "Editar cocina";
                this.imagen             = "/static/modal/brigadasUpdate.svg";
                this.cliente_value      = data.cliente_id;
                this.empresa_value      = data.empresa_id;
                this.cocina.id          = data.id;
                this.cocina.nombre      = data.nombre;
                this.cocina.descripcion = data.descripcion;
                this.cocina.direccion   = data.direccion;
                this.cocina.responsable = data.responsable;
                this.cocina.numero      = data.numero;
                this.cocina.hora_maxima = data.hora_maxima.substring(0,5);
                
                let sucursales = []
                sucursales = await data.sucursales.map( item => {
                    return item.sucursal_id;
                });
                
                this.sucursalesSeleccionadas = sucursales;
                /* setTimeout( () => {
                    this.$nextTick(()=>{
                        if(this.$refs.multSucursal !== undefined){
                            this.$refs.multSucursal.setData(sucursales);
                        }
                    });
                }, 500 ) */
                
            }
            this.isLoadingModal  = false;
            //setTimeout(function(){ document.getElementById("btnModal").click(); }, 100);
            this.dialog = true;
        },

        async cerrarModal() {
            this.dialog     = false;
            this.isSaving   = false;
            await this.resetValues();
        },
        async resetValues() {
            this.cocina = {
                cliente_id  : null,
                empresa_id  : null,
                nombre      : null,
                descripcion : null,
                direccion   : null,
                responsable : null,
                numero      : null,
                hora_maxima : null,
                sucursales  : [],
            }

            if(this.rol == 'root'){
                await this.getClientes();
                this.cliente_value = null;
                this.empresa_value = null;
                this.empresas= [];
                this.sucursales= [];
                this.sucursalesSeleccionadas = [];
                this.$nextTick(()=>{
                    if(this.$refs.multSucursal !== undefined){
                        this.$refs.multSucursal.setData([]);
                    }
                });
            }
            else if(this.rol == 'admin'){
                this.cliente_value = null;
                this.empresa_value = null;
                this.empresas= [];
                this.sucursales= [];
                this.sucursalesSeleccionadas =  [];
                this.$nextTick(()=>{
                    if(this.$refs.multSucursal !== undefined){
                        this.$refs.multSucursal.setData([]);
                    }
                });
            }
            else if(this.rol == 'admin-empresa'){
                this.sucursalesSeleccionadas =  [];
                this.$nextTick(()=>{
                    if(this.$refs.multSucursal !== undefined){
                        this.$refs.multSucursal.setData([]);
                    }
                });
            }
            else {
                this.sucursalesSeleccionadas =  [];
                this.$nextTick(()=>{
                    if(this.$refs.multSucursal !== undefined){
                        this.$refs.multSucursal.setData([]);
                    }
                });
            }

            this.filterNombre = null;
            this.sucursal_value= null;

            this.$nextTick(() => {
                if(this.$refs.form){
                    this.$refs.form.reset();
                }
            });
        },
        eliminar(data){
            Notify.Alert(
                "ADVERTENCIA",
                "¿Estás seguro que deseas eliminar la cocina " + data.nombre + "?",
                "Eliminar",
                () => {
                    this.isLoading = true;
                    apiCocinas.delete(data.id).then(response => {
                        Notify.Success("Cocina eliminada", "La cocina ha sido eliminada satisfactoriamente");
                        this.$refs.tabla.getData();
                    })
                    .catch(err => {
                        this.isLoading = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }

                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            )
        },
        guardar() {
            this.$refs.form.validate().then(success => {
                this.isSaving = true;
                if(!success) {
                    this.isSaving = false;
                    return;
                }
                

                this.cocina.cliente_id = this.cliente_value;
                this.cocina.empresa_id = this.empresa_value;
                this.cocina.sucursales = this.sucursalesSeleccionadas;

                if(this.rol == 'admin'){
                    this.cocina.cliente_id = this.datosLogin.cliente_id;
                }
                else if(this.rol == 'admin-empresa'){
                    this.cocina.cliente_id = this.datosLogin.cliente_id;
                    this.cocina.empresa_id = this.datosLogin.empresa_id;
                }
                else if(this.rol == 'admin-sucursal'){
                    this.cocina.cliente_id = this.datosLogin.cliente_id;
                    this.cocina.empresa_id = this.datosLogin.empresa_id;
                }


                this.isLoading = true;
                if(this.accion === "add") {

                    if(this.rol == 'admin-sucursal'){
                        this.cocina.sucursales = [];
                        this.cocina.sucursales.push(this.datosLogin.sucursal_id)
                    }

                    apiCocinas.store(this.cocina).then((response) => {
                        Notify.Success("Operación exitosa", "La cocina se guardó satisfactoriamente.");
                        this.$refs.tabla.getData();
                        this.cerrarModal();
                        this.$nextTick(() => {
                            this.$refs.form.reset();
                        });
                    })
                    .catch(err => {
                        this.isLoading = false;
                        this.isSaving = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
                else if(this.accion === "update") {
                    apiCocinas.update(this.cocina).then((response) => {
                        Notify.Success("Operación exitosa", "La cocina se actualizó satisfactoriamente.");
                        this.$refs.tabla.getData();
                        this.cerrarModal();
                        this.$nextTick(() => {
                            this.$refs.form.reset();
                        });
                    })
                    .catch(err => {
                        this.isLoading = false;
                        this.isSaving = false;
                        if(typeof err.response.data.error === 'string'){
                            Notify.ErrorToast(err.response.data.error);
                        }else{
                            let error = Object.values(err.response.data.error);
                            let leyenda = ``;

                            for (var i = 0; i < error.length; i++) {
                                leyenda+= `* ` + error[i] + `\n`;
                            }
                            Notify.ErrorToast(leyenda);
                        }
                    });
                }
            });
        },
        async loadModalData(){
            await this.resetValues()
            if(this.rol == 'root'){
                await this.getClientes();
            }
            else if(this.rol == 'admin'){
                this.cliente_value = this.datosLogin.cliente_id;
            }
            else if(this.rol == 'admin-empresa'){
                this.empresa_value = this.datosLogin.empresa_id;
            }
            else {
                //this.empresa_value = this.datosLogin.empresa_id;
            }
        },
        async setFilters(){
            let cliente = this.cliente_value;
            let empresa = this.empresa_value;
            let sucursal = this.sucursal_value;
            let nombre = this.filterNombre;

            if (this.rol == "admin") {    
                cliente = this.datosLogin.cliente_id;
            }
            else if(this.rol == 'admin-empresa'){
                cliente = this.datosLogin.cliente_id;
                empresa = this.datosLogin.empresa_id;
            }
            else if(this.rol == 'admin-sucursal'){
                cliente = this.datosLogin.cliente_id;
                empresa= this.datosLogin.empresa_id;
                sucursal = this.datosLogin.sucursal_id;
            }

            this.filters.cliente_id     = cliente;
            this.filters.empresa_id     = empresa;
            this.filters.sucursal_id    = sucursal;
            this.filters.nombre         = nombre;

            this.$refs.tabla.getData();
            await this.resetValues();
        },

        async getClientes(){
            let parametros = {
                activo      : true,
                paginate    : false,
                order       : 'asc',
                order_by    : 'nombre'
            }
            
            await apiClientes.getClientes(parametros).then((response) => {
                this.clientes = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar los clientes.");
            });
        },
        getEmpresas(){
            let parametros = {
                activo      : true,
                paginate    : false,
                order       : 'asc',
                order_by    : 'nombre',
                cliente_id  : this.cliente_value
            }
            apiEmpresas.getEmpresas(parametros).then((response) => {
                this.empresas = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las empresas.");
            });
        },
        getSucursales(){
            let parametros = {
                activo      : true,
                paginate    : false,
                order       : 'asc',
                order_by    : 'nombre',
                cliente_id  : this.cliente_value,
                empresa_id  : this.empresa_value
            }
            apiSucursales.getSucursales(parametros).then((response) => {
                this.sucursales = response.data;
            })
            .catch((err) => {
                console.error(err);
                Notify.ErrorToast("Ocurrió un error al cargar las sucursales.");
            });
        },
        listar(){
            if(this.rol == 'root'){
                this.getClientes();
            }
            else if(this.rol == 'admin'){
                this.filters.cliente_id = this.datosLogin.cliente_id;
                this.cliente_value = this.datosLogin.cliente_id;
            }
            else if(this.rol == 'admin-empresa'){
                this.filters.cliente_id = this.datosLogin.cliente_id;
                this.filters.empresa_id = this.datosLogin.empresa_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
            else if(this.rol == 'admin-sucursal'){
                this.filters.cliente_id = this.datosLogin.cliente_id;
                this.filters.empresa_id = this.datosLogin.empresa_id;
                this.filters.sucursal_id = this.datosLogin.sucursal_id;
            }
            else {
                this.filters.cliente_id = this.datosLogin.cliente_id;
                this.filters.empresa_id = this.datosLogin.empresa_id;
                this.empresa_value = this.datosLogin.empresa_id;
            }
        },
        redireccionar(){
            this.$router.push('/dashboard');
        },
    },
    created() {
        this.datosLogin         = this.$session.get('usuario');
        this.rol                = this.datosLogin.rol.name;
        this.listar();
    },
}

</script>